import { getCurrentInstance } from "vue"

export default function useConfirmModal() {
  const app = getCurrentInstance()

  async function openModal(type, options) {

    options.props = {
      ...options.props,
      returnValue: true,
    }
    return await app.appContext.config.globalProperties.$modal.open(type, options)
  }

  return {
    openModal,
  }
}